import * as React from 'react';

import NotificationDetails from './NotificationDetails';
import NotificationList from './NotificationList';

export default class extends React.Component {
    constructor(args) {
        super(args);
        this.state = {
            selectedNotificationId: null,
            currentSection: 'inbox'
        };
    }

    componentDidMount() {
        this.props.notifications.on('add change remove', this.handleChange.bind(this));
    };

    componentWillUnmount() {
        this.props.notifications.off('add change remove', this.handleChange.bind(this));
    };

    handleChange() {
        this.forceUpdate();
    }

    openNotification(id) {
        const notification = this.props.notifications.get(id);
        if (!notification.get('read')) {
            notification.save({ read: true }, { patch: true });
        }
        this.setState({ selectedNotificationId: notification.id });
    };

    deleteNotification(id) {
        let notification = this.props.notifications.get(id);
        notification.destroy();

        const nextNotification = this.props.notifications.first();

        if (nextNotification) {
            this.openNotification(nextNotification.id);
        } else {
            this.setState({ selectedNotificationId: null });
        }
    };

    render() {
        const currentNotification = this.props.notifications.find(notification => notification.id === this.state.selectedNotificationId);
        return (
            <div id="notifications-container">
                <NotificationList
                    currentSection={this.state.currentSection}
                    notifications={this.props.notifications}
                    onNotificationSelected={id => this.openNotification(id)}
                    selectedNotificationId={this.state.selectedNotificationId}
                />
                <NotificationDetails
                    notification={currentNotification}
                    onDelete={id => this.deleteNotification(id)}
                />
            </div>
        );
    };
}
